import React from "react";
import NavComplete from "./Component/Navbar1";
import Footer from "./Component/footer";
import { Container, Row } from "react-bootstrap";
import "./information&promo.css";
import informasi_img from "./Assets/informasi-doodle.png";
import Card from "react-bootstrap/Card";
import { useState, useEffect } from "react";

const Information = () => {
  const [all_cards, setAllcards] = useState([]);
  useEffect(() => {
    const cards = [
      {
        judul: `${
          localStorage.getItem("bahasa") === "ing"
            ? ` Avoid 5 Unnoticed Causes of Fine Scratches on Your Car's Surface!`
            : `Hindari 5 Penyebab Munculnya Baret Halus Pada Permukaan Mobil yang
            Jarang Disadari!`
        }`,
        image: "https://i.ibb.co.com/8jzmMc1/ezgif-com-gif-maker.webp",
        routes:
          "/Informasi/Hindari-5-Penyebab-Munculnya-Baret-Halus-Pada-Permukaan-Mobil-yang-Jarang-Disadari!",
        para: `${
          localStorage.getItem("bahasa") === "ing"
            ? ` Imagine you've been working tirelessly, exerting your energy and mental efforts. With every payday, you set aside a portion of your salary to buy a car....`
            : ` Bayangkan kamu sudah kerja banting tulang, cape tenaga, dan cape pikiran. Setiap tanggal gajian kamu menyisihkan sebagian gaji
                kamu untuk membeli mobil.....`
        }`,
        tgl: "25 oktober 2023",
      },
      {
        judul: `${
          localStorage.getItem("bahasa") === "ing"
            ? `This is what causes mold on the surface of car paint and glass`
            : `Ternyata Ini yang Menyebabkan Munculnya Jamur Pada Permukaan Cat dan Kaca Mobil`
        }`,
        image: "https://i.ibb.co.com/PCNWxYQ/ezgif-com-gif-maker-1.webp",
        routes:
          "/Informasi/Ternyata-Ini-yang-Menyebabkan-Munculnya-Jamur-Pada-Permukaan-Cat-dan-Kaca-Mobil",
        para: `${
          localStorage.getItem("bahasa") === "ing"
            ? ` If you think that mold can only grow on food, fix your mistake! Because it turns out that mold can grow anywhere...`
            : ` Kalo kamu beranggapan bahwa jamur itu hanya bisa tumbuh pada makanan, fix kamu salah! Karena ternyata jamur bisa tumbuh di mana saja...`
        }`,
        tgl: "25 oktober 2023",
      },
      {
        judul: `${
          localStorage.getItem("bahasa") === "ing"
            ? `3 Secrets to Remove Scratches on Car Body Surfaces`
            : `3 Rahasia Menghilangkan Baret Pada Permukaan Body Mobil`
        }`,
        image: "https://i.ibb.co.com/0sM5KT5/mobil-lecet.webp",
        routes:
          "/Informasi/3-Rahasia-Menghilangkan-Baret-Pada-Permukaan-Body-Mobil",
        para: `${
          localStorage.getItem("bahasa") === "ing"
            ? `Scratches on the surface of the car really ruin the aesthetics and beauty of our car. Especially if you are a perfectionist, it must be really annoying when the surface of your car body is scuffed.`
            : `Baret pada permukaan mobil benar-benar merusak estetika dan keindahan mobil kita. Apalagi kalo kamu termasuk tipikal orang yang perfeksionis gitu, pasti jengkel banget ketika permukaan body mobil kamu lecet.`
        }`,
        tgl: "25 oktober 2023",
      },
      {
        judul: `${
          localStorage.getItem("bahasa") === "ing"
            ? `5 Steps to Keep Your Car's Engine Clean and Durable!`
            : `5 Langkah Ini Akan Membuat Mesin Mobil Kamu Bersih dan Lebih Awet!`
        }`,
        image: "https://i.ibb.co.com/Q89Ny03/mobil-we.webp",
        routes:
          "/Informasi/5-Langkah-Ini-Akan-Membuat-Mesin-Mobil-Kamu-Bersih-dan-Lebih-Awet!",
        para: `${
          localStorage.getItem("bahasa") === "ing"
            ? `Maintaining a car involves not only cleaning its exterior and interior but also its engine....`
            : `Merawat mobil bukan hanya dengan membersihkan bagian eksterior dan interior mobil, tetapi juga bagian mesinnya....`
        }`,
        tgl: "22 November 2023",
      },
      {
        judul: `${
          localStorage.getItem("bahasa") === "ing"
            ? `6 Secrets to Maintain Your Car's Interior to Keep it Bright and Dust-Free`
            : `6 Rahasia Merawat Interior Mobil Agar Tidak Kusam dan Berdebu`
        }`,
        image: "https://i.ibb.co.com/kgdkfrx/interior.webp",
        routes:
          "/Informasi/6-Rahasia-Merawat-Interior-Mobil-Agar-Tidak-Kusam-dan-Berdebu",
        para: `${
          localStorage.getItem("bahasa") === "ing"
            ? `You might have encountered people around you who only care about their external appearance.....`
            : `Kamu pasti pernah mendapati bahwa ada orang-orang di sekeliling kamu yang hanya peduli dengan tampilan luarnya saja.....`
        }`,
        tgl: "27 November 2023",
      },
    ];
    setAllcards(cards);
  }, []);
  const handleCardClick = (link) => {
    window.location.href = `${link}`;
  };
  return (
    <>
      <NavComplete />
      <section className="welcome-section-i">
        <img src={informasi_img} alt="car" className="welcome-car-image-i" />
        <Container className="container-1-i">
          <div className="welcome-content-i">
            <h1 className="roleway">
              {localStorage.getItem("bahasa") === "ing" ? "Blog" : "Artikel"}
            </h1>
          </div>
          <Container className="table-information" fluid>
            <Row className="row-cards">
              {all_cards.map((item, index) => {
                return (
                  <Card
                    style={{ maxWidth: "350px", padding: "0px 0px" }}
                    bg="dark"
                    key={index}
                    text="white"
                    onClick={() => handleCardClick(item.routes)}
                    className="card-shadow"
                  >
                    <Card.Img
                      variant="top"
                      src={item.image}
                      style={{ maxHeight: "250px", maxWidth: "100%" }}
                    ></Card.Img>
                    <Card.Body>
                      <h2 className="gotham">{item.judul}</h2>
                      <Card.Text className="nunito">{item.para}</Card.Text>
                      <div
                        style={{
                          marginBottom: "5px",
                          gap: "20px",
                          marginTop: "30px",
                        }}
                      >
                        <i
                          style={{ padding: "0px 2px" }}
                          class="bi bi-person"
                        ></i>
                        <a
                          style={{ padding: "0px 5px", marginRight: "10px" }}
                          target="blank_"
                          href="https://www.instagram.com/rezzaalviansyah/"
                        >
                          Rezza
                        </a>
                        <i
                          style={{ padding: "0px 2px" }}
                          class="bi bi-calendar4-week"
                        ></i>
                        <span style={{ padding: "0px 5px" }}>{item.tgl}</span>
                      </div>
                    </Card.Body>
                  </Card>
                );
              })}
            </Row>
          </Container>
        </Container>
        <Footer />
      </section>
    </>
  );
};

export default Information;
